import { createContext, useContext, type ReactNode } from 'react';
import type { ApiClient } from './api/client';
import type { AuthService } from './auth/types';

export interface Services {
  api: ApiClient;
  auth: AuthService;
  mock: boolean;
}

const ServicesContext = createContext<Services | null>(null);

export function ServicesProvider({ services, children }: { services: Services; children: ReactNode }) {
  return <ServicesContext.Provider value={services}>{children}</ServicesContext.Provider>;
}

export function useServices(): Services {
  const s = useContext(ServicesContext);
  if (!s) throw new Error('useServices must be used inside ServicesProvider');
  return s;
}

export function useApi(): ApiClient {
  return useServices().api;
}
